import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/esnext.json.parse.js";
import { __decorate } from "tslib";
import StandardButton from "@/components/buttons/StandardButton.vue";
import axios from "axios";
import Timer from "@/components/quiz/Timer.vue";
import { Carousel, Navigation, Pagination, Slide } from "vue3-carousel";
import { Component, Prop, Ref, Vue } from "vue-facing-decorator";
import QuizViewerLayout from "@/components/layout/QuizViewerLayout.vue";
import QuizViewerCarousel from "@/components/quiz/QuizViewerCarousel.vue";
import WElMessage from "@/components/wrappers/w-elmessage.vue";
import OpenQuestionQuiz from "@/components/quiz/OpenQuestionQuiz.vue";
import QuizPreamble from "@/components/quiz/QuizPreamble.vue";
import InformationDialog from "@/components/dialogs/NotificationDialog.vue";
import { Events } from "@/events/events";
let OpenQuestionQuizPlayer = class OpenQuestionQuizPlayer extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "quizId", void 0);
    _defineProperty(this, "quizResultJsonString", void 0);
    _defineProperty(this, "timer", void 0);
    _defineProperty(this, "remainingSeconds", void 0);
    _defineProperty(this, "isSpeachTemplate", void 0);
    _defineProperty(this, "canEdit", void 0);
    _defineProperty(this, "timerComponent", void 0);
    _defineProperty(this, "openQuizViewerCarousel", void 0);
    _defineProperty(this, "quiz", void 0);
    _defineProperty(this, "timeElapsed", false);
    _defineProperty(this, "BASE_API_QUIZ", '/api/v2/quiz');
    _defineProperty(this, "activateNextStepButton", true);
    _defineProperty(this, "activeStep", 0);
    _defineProperty(this, "quizAnswered", false);
    _defineProperty(this, "realtimeUserAnswer", null);
  }
  mounted() {
    this.initQuiz();
    if (this.quizResultJsonString) {
      this.quizAnswered = true;
      this.realtimeUserAnswer = JSON.parse(this.quizResultJsonString);
    }
  }
  unmounted() {
    if (this.timer && this.timerComponent.getRemainingSeconds() > 0) {
      this.timerComponent.stopCounting();
    }
  }
  get preambleItems() {
    const preambleItems = [this.$t('view.speach.openQuestion.start.text4'), this.$t('view.speach.openQuestion.start.textWarning')];
    preambleItems.unshift(this.timer ? this.$t('view.speach.openQuestion.start.text2', {
      minutes: this.timer
    }) : this.$t('view.speach.openQuestion.start.text3'));
    return preambleItems;
  }
  get footerButtonLabel() {
    switch (this.activeStep) {
      case 0:
        return this.$t('view.speach.openQuestion.start.startButton').toString();
      default:
        return this.$t('view.speach.openQuestion.start.nextStepButton').toString();
    }
  }
  get isPreambleSlide() {
    return !this.quizAnswered && this.activeStep === 0;
  }
  onSlideChange(eventData) {
    this.activeStep = eventData.currentSlideIndex;
  }
  initQuiz() {
    axios.get(`${this.BASE_API_QUIZ}/${this.quizId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      this.quiz = response.data;
    }).catch(() => {
      WElMessage.showErrorMessage(this.$t('errors.default'));
    });
  }
  onAnswerChange(userAnswer) {
    this.realtimeUserAnswer = userAnswer;
    this.activateNextStepButton = !!this.realtimeUserAnswer?.questions[0]?.responseContent?.trim().length;
  }
  async saveAnswer() {
    await axios.put(`${this.BASE_API_QUIZ}/${this.quiz?.id}/open-question-answer`, {
      userAnswerJson: JSON.stringify(this.realtimeUserAnswer)
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).catch(e => {
      throw new Error(e);
    });
  }
  async onNextStepButtonClick() {
    switch (this.activeStep) {
      case 0:
        if (this.timer) {
          this.timerComponent.startCounting();
        }
        this.moveToNextSlide();
        trig(Events.STAT_START);
        break;
      case 1:
        if (this.timer && this.timerComponent.getRemainingSeconds() > 0) {
          this.timerComponent.stopCounting();
        }
        await this.saveAnswerAndDisplayResultPage();
        break;
    }
  }
  async saveAnswerAndDisplayResultPage() {
    try {
      if (!this.canEdit) {
        await this.saveAnswer();
      }
      this.quizAnswered = true;
    } catch (e) {
      WElMessage.showErrorMessage(this.$t('errors.default'));
    }
  }
  moveToNextSlide() {
    this.openQuizViewerCarousel?.next();
    this.activateNextStepButton = false;
  }
  countdownEnd() {
    this.timeElapsed = true;
    this.saveAnswerAndDisplayResultPage();
  }
};
__decorate([Prop({
  required: true
})], OpenQuestionQuizPlayer.prototype, "quizId", void 0);
__decorate([Prop({
  default: ''
})], OpenQuestionQuizPlayer.prototype, "quizResultJsonString", void 0);
__decorate([Prop({
  default: 0
})], OpenQuestionQuizPlayer.prototype, "timer", void 0);
__decorate([Prop({
  default: 0
})], OpenQuestionQuizPlayer.prototype, "remainingSeconds", void 0);
__decorate([Prop({
  default: false
})], OpenQuestionQuizPlayer.prototype, "isSpeachTemplate", void 0);
__decorate([Prop({
  default: false
})], OpenQuestionQuizPlayer.prototype, "canEdit", void 0);
__decorate([Ref('timerComponent')], OpenQuestionQuizPlayer.prototype, "timerComponent", void 0);
__decorate([Ref('openQuizViewerCarousel')], OpenQuestionQuizPlayer.prototype, "openQuizViewerCarousel", void 0);
OpenQuestionQuizPlayer = __decorate([Component({
  components: {
    QuizPreamble,
    OpenQuestionQuiz,
    QuizViewerCarousel,
    QuizViewerLayout,
    InformationDialog,
    Pagination,
    Navigation,
    Slide,
    Carousel,
    Timer,
    StandardButton
  }
})], OpenQuestionQuizPlayer);
export default OpenQuestionQuizPlayer;